import React, { useEffect, useMemo, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Tabletop from 'tabletop'
import { HearkenStatus } from 'types/hearkenStatus'
import {
  GoogleSheetResponse,
  HearkenConfiguration
} from 'types/googleSheetResponse'
import logo from 'images/logo-outlined.svg'
import Intro from 'text/intro.md'
import styles from './styles.module.scss'
import config from 'config'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = config.articleId

interface Category {
  Spaltenname: string
  Header: string
  Subheader: string
}

function AppComponent() {
  const [hearkenStatus, setHearkenStatus] = useState<HearkenStatus>(
    HearkenStatus.PUBLISHING
  )
  const [allStatus, setAllStatus] = useState<HearkenConfiguration>({
    hearkenStatus: HearkenStatus.PUBLISHING
  })
  const [articleIDs, setArticleIDs] = useState<string[]>([])

  useEffect(() => {
    Tabletop.init({
      key: config.googleSheetKey,
      simpleSheet: false,
      callback: (data: GoogleSheetResponse) => {
        // Set Hearken Status
        setAllStatus(data.Status.elements[0])
        setHearkenStatus(data.Status.elements[0].hearkenStatus as HearkenStatus)

        // Gather all article IDs
        const articleRows = data.Artikel.elements
        setArticleIDs(articleRows.map(row => row.Antworten))
      }
    })
  }, [])

  const areAnyArticlesAvailable = useMemo(() => articleIDs.length > 0, [
    articleIDs
  ])

  return (
    <div className={'index ' + styles.index}>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className={'ui vertical very relaxed segment ' + styles.cover}>
        <div className='ui container'>
          <h1 className='ui image centered header'>
            <img src={logo} alt='Was Zürich wissen will' className='ui image' />
            <div className='content'>
              Haben wir etwas übersehen?
              <a
                href='mailto:zuerich@tages-anzeiger.ch?subject=%5BLeserhinweis%5D'
                className='sub header'
              >
                Schreiben Sie uns Ihren Hinweis
              </a>
            </div>
          </h1>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <Intro />
        </div>
      </div>

      {navigator.userAgent !== 'ReactSnap' && areAnyArticlesAvailable && (
        <div
          id='articles'
          className={
            'ui vertical inverted segment ' + styles.categoryBackground
          }
        >
          <div className='ui container'>
            <h2 className={styles.articlesHeader}>
              Folgende Beiträge entstanden dank Ihrer Fragen:
            </h2>
            <ArticleTeasers
              articleIds={articleIDs}
              numberOfCards='three'
              className='doubling'
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE}
            />
          </div>
        </div>
      )}

      <Footer
        mailTo='zuerich@tages-anzeiger.ch'
        articleId={ARTICLE_ID}
        questions={[
          'Wie gefällt Ihnen, dass Sie die Themen mitbestimmen können?'
        ]}
        credits={[
          ['Projektleitung', 'Dinja Plattner, Marc Brupbacher'],
          ['Programmierung', 'Kaspar Manz']
        ]}
      />
    </div>
  )
}

export const App = hot(AppComponent)
